import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root:
            'rounded-(--border-radius-md) px-6 py-5 ' +
            'bg-[linear-gradient(145deg,var(--surface-list-bg-start),rgba(230,235,242,0.72))] ' +
            '[backdrop-filter:blur(1.125rem)_saturate(1.4)] border-[0.063rem] border-solid border-(--white-alpha-70) ' +
            'shadow-[0.375rem_0.375rem_0.875rem_rgba(163,177,198,0.32),-0.375rem_-0.375rem_0.875rem_rgba(255,255,255,0.88)]',
        title:
            'mb-[0.85rem] border-b-[0.063rem] border-b-(--slate-muted-alpha-20) pb-[0.6rem] ' +
            'font-(family-name:--secondary-font) text-[0.78rem] uppercase tracking-[0.07em] text-(--accent-solid)',
        content: 'flex flex-col gap-0'
    }
} satisfies ComponentTheme;
